import waitForAnalytics from './wait'

declare var window: any

export default function reset(): void {
  waitForAnalytics(() => window.analytics.reset())
}
